import React from 'react';
import PropTypes from 'prop-types';
import './PrintPreview.css';
import Dictionary from '../../../model/Dictionary';
import { Button } from 'material-ui';

const PrintPreview = ({ title, onPrint }) => (
  <div className='print-preview'>
    <h5 className='print left'>
      <span>{title}</span>
    </h5>
    <div className='print right'>
      <Button onClick={onPrint} variant='raised' color='primary'>
        {Dictionary.review.print}
      </Button>
    </div>
  </div>
);

PrintPreview.propTypes = {
  title: PropTypes.string,
  onPrint: PropTypes.func,
};

export default PrintPreview;



// WEBPACK FOOTER //
// ./src/components/review/printPreview/PrintPreview.js